export enum OrderbookFilterEnum {
  BIDS = "Bids",
  OFFERS = "Offers"
}
